const routes = {
  login: 'auth/login',
  logout: 'auth/logout',
};

export default routes